export default "__VITE_ASSET__xCNPbTNF__"